import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { Separator } from '@/components/ui/separator';
import { createTvController } from '@/lib/api/tvController';
import { TvController } from '@/lib/schema/tvController';
import { TvControllerForm } from '@/pages/tv-controllers/tvControllerForm';

function submitTvController(data: TvController) {
  return createTvController(data);
}

export default function CreateTvControllerPage() {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: submitTvController,
    onSuccess: () => {
      navigate('/tv-controllers'); // Redirect to TV controllers list after successful creation
    },
    onError: (error) => {
      console.error('Error creating TV controller:', error);
    },
  });

  const onSubmit = (data: TvController) => {
    mutation.mutate(data);
  };

  return (
    <div className="w-full pb-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Create device</h1>
        </div>
      </div>

      <Separator className="my-6" />

      <TvControllerForm mutation={mutation} onSubmit={onSubmit} />
    </div>
  );
}
